// extracted by mini-css-extract-plugin
export default {"img":"Banner_img__TDZ7r","container":"Banner_container__Q07kg","body":"Banner_body__gXUwY","name":"Banner_name__8KHsY","description":"Banner_description__qLSxS"};